import * as React from 'react'
import {
  DirectionProvider as BaseDirectionProvider,
  useDirection,
  type DirectionProviderProps,
} from '@base-ui/react/direction-provider'

// ---------------------------------------------------------------------------
// DirectionProvider — migrated from Radix to Base UI
// ---------------------------------------------------------------------------
// Base UI's DirectionProvider uses a `direction` prop (type 'ltr' | 'rtl').
// We preserve the `dir` alias from the Radix-era API for backward compatibility.
// When both are supplied, `direction` wins (matching the Radix-era behaviour
// where the Radix `dir` prop was set to `direction ?? dir`).
// ---------------------------------------------------------------------------

export namespace Direction {
  export interface Props extends DirectionProviderProps {
    /** Alias for `direction`. Kept for backward compatibility with the Radix-era API. */
    dir?: DirectionProviderProps['direction']
  }
}

function DirectionProvider({ dir, direction, children }: Direction.Props) {
  return <BaseDirectionProvider direction={direction ?? dir}>{children}</BaseDirectionProvider>
}

export { DirectionProvider, useDirection }
